import { logNotificationUpdateForDiagnostics } from '../actions/publicActions';
import { MaxLogsForDiagnosticsPanel } from '../constants';
import insertNotificationUpdateLog from '../mutators/insertNotificationUpdateLog';
import removeNotificationUpdateLog from '../mutators/removeNotificationUpdateLog';
import getStore from '../store/store';
import ensureLoggerInitialized from '../utils/initializeLogger';
import { now } from 'owa-datetime';
import { isFeatureEnabled } from 'owa-feature-flags';
import { orchestrator } from 'satcheljs';

orchestrator(logNotificationUpdateForDiagnostics, actionMessage => {
    if (!isFeatureEnabled('cal-notificationDiagnostics')) {
        return;
    }

    const { notificationUpdateLogs } = getStore();

    if (notificationUpdateLogs.length == MaxLogsForDiagnosticsPanel) {
        // if we already have the maxLogs, then remove the first
        removeNotificationUpdateLog();
    }

    ensureLoggerInitialized();
    if (!actionMessage.notificationUpdateLog.timestamp) {
        // If timestamp is not passed, then assume that time of calling the log is the approximate time of request made
        actionMessage.notificationUpdateLog.timestamp = now();
    }
    insertNotificationUpdateLog(actionMessage.notificationUpdateLog);
});
